import { type TSearchConfigAPIResponse } from '@atlassian/search-client/fetch-search-config';

/**
 * Checks if Jira issues are indexed for the given tenant/cloudId.
 */
export const getJiraIssueIndexedForTenant = (
	firstPartyResponse?: TSearchConfigAPIResponse,
	cloudId?: string,
): boolean | undefined => {
	if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) {
		return false;
	}
	return firstPartyResponse.siteMetadata.find((metadata) => metadata.siteId === cloudId)
		?.isJiraIssueIndexed;
};
